export function checkElementScrollEnd(element: HTMLElement) {
  const { scrollTop, offsetHeight, scrollHeight } = element
  return scrollTop + offsetHeight >= scrollHeight
}

export function disableBodyScroll() {
  document.body.style.overflow = 'hidden'
}

export function enableBodyScroll() {
  document.body.style.overflow = 'auto'
}

export function scrollTop() {
  document.body.scrollTop = document.documentElement.scrollTop = 0
}
